import { render, staticRenderFns } from "./personManage.vue?vue&type=template&id=428d6c1b&scoped=true&"
import script from "./personManage.vue?vue&type=script&lang=js&"
export * from "./personManage.vue?vue&type=script&lang=js&"
import style0 from "./personManage.vue?vue&type=style&index=0&id=428d6c1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d6c1b",
  null
  
)

export default component.exports